import {
  TSupportedLocale,
} from '@/types/i18n.ts';

/**
 * A page of the user manual, given as its source path below `services/user_manual/docs/<locale>/`.
 * @example 'applications/recipe-builder/index.md'
 */
export type TUserManualPage = `${string}.md`;

/**
 * The locales the user manual is built in, one per `services/user_manual/locales/<locale>.toml`.
 * Every built locale contains every page, falling back to the English text where a translation
 * is missing.
 */
export const USER_MANUAL_LOCALE_LIST: TSupportedLocale[] = [
  'en',
  'de',
];

const USER_MANUAL_DEFAULT_LOCALE: TSupportedLocale = 'en';

function getUserManualPageUrlPath(page: TUserManualPage): string {
  const pathWithoutExtension = page.replace(/\.md$/, '');
  if (pathWithoutExtension === 'index') {
    return '';
  }
  if (pathWithoutExtension.endsWith('/index')) {
    return pathWithoutExtension.slice(0, -'index'.length);
  }
  return `${pathWithoutExtension}/`;
}

/**
 * Builds the URL of a user manual page in the given locale, or in English if the user manual is
 * not built in that locale. Without a page, it links to the start page of the user manual.
 */
export function getUserManualUrl(
  userManualBaseUrl: string,
  locale: string,
  page?: TUserManualPage,
): string {
  const manualLocale = USER_MANUAL_LOCALE_LIST.includes(locale as TSupportedLocale)
    ? locale
    : USER_MANUAL_DEFAULT_LOCALE;
  const localeUrl = `${userManualBaseUrl}/${manualLocale}/`;
  if (page === undefined) {
    return localeUrl;
  }
  return `${localeUrl}${getUserManualPageUrlPath(page)}`;
}
